/* eslint-disable max-len */
import React, { useState, useMemo } from 'react';
import { Text, Pane, List, Button, CompositeTextInput, Content } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import TypeToFieldFilter from "../filter/TypeToFieldFilter.js";
import FieldListRenderer from "./FieldListRenderer.js";
import Model from "../filter/GroupedTextFilterModel.js";
import S from './SearchEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.group.SearchEditor');
function SearchEditor(props) {
  const {
    value,
    onChange,
    eventData,
    objectType,
    searchMin = 8
  } = props;
  const [filter, setFilter] = useState('');
  const onSetFilter = ({
    value
  }) => setFilter(value);
  const attrs = Attributes.getAttributesFor(objectType);
  const avail = useMemo(() => attrs?.filter(attr => TypeToFieldFilter.get(attr?.valueType) && attr?.blueprint?.field)?.map(attr => ({
    name: attr.displayName || attr.name,
    attr,
    active: Model.fields().getAll(value).some(i => i.attrName === attr.name)
  })), [attrs, Model.fields().getAll(value)]);
  const display = useMemo(() => avail.filter(i => filter ? i?.name?.toLowerCase()?.includes(filter?.toLowerCase()) : true), [avail, filter]);
  if (value == null) {
    return null;
  }
  const onChangeFieldActive = ({
    data,
    value: evtValue
  }) => {
    if (evtValue) {
      const nModel = Model.fields().add(value, Model.field.create({
        attrName: data?.attr?.name,
        displayName: data?.attr?.displayName
      }));
      onChange({
        data: eventData,
        value: nModel,
        oldValue: value
      });
    } else {
      const fields = Model.fields().getAll(value);
      const toRemove = fields.findIndex(i => i?.attrName === data?.attr?.name);
      const nModel = Model.fields().removeAt(value, toRemove);
      onChange({
        data: eventData,
        value: nModel,
        oldValue: value
      });
    }
  };
  const onClear = () => {
    const nModel = Model.fields().setAll(value, []);
    onChange({
      data: eventData,
      value: nModel,
      oldValue: value
    });
  };
  return /*#__PURE__*/_jsx(Pane, {
    className: S.editor,
    variant: "editor",
    children: /*#__PURE__*/_jsxs(Content, {
      className: S.pad,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: avail.length > searchMin && /*#__PURE__*/_jsx(CompositeTextInput, {
          variant: "attrSearch|search",
          button: null,
          value: filter,
          onChange: onSetFilter,
          changeOnReturn: false,
          alwaysFireOnReturn: false
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        layout: "flex:colL",
        children: /*#__PURE__*/_jsx("div", {
          className: S.list,
          children: /*#__PURE__*/_jsx(List.Dynamic, {
            items: display,
            itemProps: {
              onChangeFieldActive
            },
            component: FieldListRenderer
          })
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        layout: "flex:colM",
        style: {
          alignItems: 'flex-start'
        },
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClear,
          disabled: !Model.fields().getAll(value)?.length,
          variant: "linkTable",
          children: t('clear')
        }), /*#__PURE__*/_jsx(Text, {
          variant: "hint|caption",
          children: t('caption')
        })]
      })]
    })
  });
}
export default SearchEditor;